import styles from "./styles.module.scss";

import body from "./img/body.png";
import dish from "./img/dish.png";
import fire from "./img/fire.png";
import happy from "./img/happy.png";
import thumb from "./img/thumb.png";

const DATA = [
  {
    img: fire,
    text: "Toned up body: get in shape quickly and easily",
  },
  {
    img: body,
    text: "10-min high-efficiency workout sets for any body area you need",
  },
  {
    img: thumb,
    text: "Alleviated tension all throughout the body",
  },
  {
    img: happy,
    text: "100+ exercises to improve flexibility and mobility",
  },
  {
    img: dish,
    text: "Custom program to follow every day",
  },
];

export const Benefits = () => {
  return (
    <div className={styles.benefits}>
      <p className={styles.title}>Highlights of your plan</p>
      <div className={styles.list}>
        {DATA.map(({ img, text }, index) => (
          <div key={index} className={styles.listItem}>
            <div className={styles.icon}>
              <img src={img} />
            </div>
            <p>{text}</p>
          </div>
        ))}
      </div>
      <p className={styles.disclaimer}>
        *Disclaimer: In order to achieve the best possible results, it's crucial
        to consistently exercise and follow a balanced diet. We encourage you to
        consult with a healthcare professional before starting any exercise
        program.
      </p>
    </div>
  );
};
